import Lyric from './Lyric'
import padStart from 'lodash-es/padStart'

/**
 * 逐行歌词
 */
export default class Lrc extends Lyric {
  constructor(type = 'lyricLrc') {
    super(type)
    this.ext = 'lrc'
    this._template = `[ti:__trackName__]
[ar:__singerName__]
[al:__albumName__]
[by:__author__]
[offset:0]
__content__`
  }

  /**
   * @override
   */
  _getLineMark(lineTime) {
    const ONE_MINUTE_MILL = 60000
    const startTime = lineTime[0]

    let minute = startTime >= ONE_MINUTE_MILL ? parseInt(startTime / ONE_MINUTE_MILL, 10) : '0'
    minute = padStart(minute, 2, '0')
    let second = parseInt((startTime % ONE_MINUTE_MILL) / 1000, 10)
    second = padStart(second, 2, '0')
    let mill = parseInt((startTime % ONE_MINUTE_MILL) % 1000, 10)
    mill = padStart(`${mill}`.substring(0, 2), 2, '0')

    return `[${minute}:${second}.${mill}]`
  }

  /**
   * @override
   */
  _getWordMark(lineTime, wordObj) {
    return wordObj.word
  }
}
